import { Box, styled } from '@mui/joy';

interface IProps {
  inline?: boolean;
  width?: string;
}

const propsToSkip = ['inline', 'width'];
const shouldForwardProp = (prop: string) => !propsToSkip.includes(prop);

export const FieldGroupWrapper = styled(Box, { shouldForwardProp })<IProps>(({ inline }) => ({
  display: 'flex',
  flexDirection: inline ? 'row' : 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '10px',
}));

export const FieldWrapper = styled(Box, { shouldForwardProp })<IProps>(({ width }) => ({
  width,
}));
